// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tgAzP","content":"styles_content__3fCE0","row":"styles_row__1xhcI","footer":"styles_footer__NY_z8","phraseLength":"styles_phraseLength__1c_jT"};